import { Article } from './Article';

  export class jou_number {
      num_uid:        string;
      issue_file_url: string;
      num_name:       string;
      num_issue:      string;
      cover_photo:    string;
      issue_name:     null;
      is_special:     string;
      articles: Article[];
  }

    export class Year {
        publish_year: string;
        jou_numbers: jou_number[];
    }

    export class RootObject {
        years: Year[];
    }

    
